<label>{{titleName}}</label>
<ngb-tabset [destroyOnHide]="false" class="mb-3">
	<ngb-tab *ngFor="let language of languages; let i = index">
		<ng-template ngbTabTitle> {{language.languageName}}</ng-template>
		<ng-template ngbTabContent>
			<div class="form-group mt-1">
				<input [value]="translationArray[i][bindingAttribute]" class="form-control"
					   placeholder="Site Name" (change)="changeInput($event, i ,'name')">
			</div>
		</ng-template>
	</ngb-tab>
</ngb-tabset>